/**
 * CardAsync Action Creators
 */

import { Actions } from "root/store/helpers/Actions";

export interface IHelpersActionCreator {
  type: string;
  payload: boolean;
}

const setShowLanguageModal: (payload: boolean) => IHelpersActionCreator = (
  payload: boolean
): IHelpersActionCreator => ({
  type: Actions.SET_SHOW_LANGUAGE_MODAL,
  payload: payload,
});

export { setShowLanguageModal };



// WEBPACK FOOTER //
// ./src/store/helpers/ActionCreators.tsx